import { render, staticRenderFns } from "./AdditionalFieldsAccordion.vue?vue&type=template&id=7527558e&scoped=true&"
import script from "./AdditionalFieldsAccordion.vue?vue&type=script&lang=js&"
export * from "./AdditionalFieldsAccordion.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalFieldsAccordion.vue?vue&type=style&index=0&id=7527558e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7527558e",
  null
  
)

export default component.exports